export const SAVE_DOCUMENTS = "SAVE_DOCUMENTS";
export const GET_DOCUMENTS = "GET_DOCUMENTS";
export const CLEAR_LIST_DOCUMENTS = "CLEAR_LIST_DOCUMENTS";
export const DOWNLOAD_DOCUMENT = "DOWNLOAD_DOCUMENT";
export const TOGGLE_SIDE_BAR = "TOGGLE_SIDE_BAR";

export const saveDocuments = (documents) => ({
	type: SAVE_DOCUMENTS,
	documents
});

export const getDocuments = () => ({
	type: GET_DOCUMENTS,
});

export const clearListDocuments = () => ({
	type: CLEAR_LIST_DOCUMENTS
});

export const toggleSideBar = (bool) => ({
	type: TOGGLE_SIDE_BAR,
	bool
});